import { useEffect, useRef, useState } from 'react'

export const useMinutesSecondsTimer = (
  minutes = 0,
  seconds = 30,
  shouldStart = false,
  onExpire = () => {}
) => {
  const totalInitialSeconds = minutes * 60 + seconds
  const timeLeftRef = useRef(totalInitialSeconds)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const [formattedTime, setFormattedTime] = useState({
    minutes: Math.floor(totalInitialSeconds / 60),
    seconds:
      totalInitialSeconds % 60 < 10 ? `0${totalInitialSeconds % 60}` : totalInitialSeconds % 60,
  })

  useEffect(() => {
    if (shouldStart && timeLeftRef.current > 0) {
      intervalRef.current = setInterval(() => {
        timeLeftRef.current -= 1
        setFormattedTime({
          minutes: Math.floor(timeLeftRef.current / 60),
          seconds:
            timeLeftRef.current % 60 < 10
              ? `0${timeLeftRef.current % 60}`
              : timeLeftRef.current % 60,
        })
        if (timeLeftRef.current <= 0) {
          clearInterval(intervalRef.current)
          onExpire()
        }
      }, 1000)
    }

    return () => clearInterval(intervalRef.current)
  }, [shouldStart, onExpire])

  const resetTimer = () => {
    clearInterval(intervalRef.current)
    timeLeftRef.current = totalInitialSeconds
    setFormattedTime({
      minutes: Math.floor(totalInitialSeconds / 60),
      seconds:
        totalInitialSeconds % 60 < 10 ? `0${totalInitialSeconds % 60}` : totalInitialSeconds % 60,
    })
  }

  return { timeLeft: timeLeftRef.current, formattedTime, resetTimer }
}
